
import instance from "./instance";

export const getCardPayment = async (data) => {
    const request = {...data}
    request.source.type = "token";
    return instance.post("/payment/getCardPayment", request, { headers: { 'Content-Type': 'application/json' } });
}
export const getPaymentById = async (data) => {
    return instance.post("/payment/getPaymentById", data, { headers: { 'Content-Type': 'application/json' } });
}
export const getSadadPayment = async (data) => {
    console.log(data,"SADAD_DATA")
    return instance.post("/payment/getSadadPaymentGenerationDev", data, { headers: { 'Content-Type': 'application/json' } });
}

export const getSadadFlightDelayPayment = async (data) => {
    return instance.post("/payment/flightDelay/getSadadPaymentGeneration", data, { headers: { 'Content-Type': 'application/json' } });
}
export const createTamaraSession = async (data) => {
    return instance.post("/createSession", data, { headers: { 'Content-Type': 'application/json' } });
}
export const verifyTamaraOrder = async (data) => {
    return instance.post("/payment/verifyOrder", data, { headers: { 'Content-Type': 'application/json' } });
}

export const getQuotationDetails = async (data) => {
    return instance.post("/travel/searchQuotationDev",
        data,
        {
            headers: { "Content-Type": "application/json" },
        }
    );
};